import { useRef, useState } from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { deleteBankLinking, postAccountLinking } from 'lib/api/banks';
import { Button, IconButton, Typography, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import SnackBarComponent from 'components/shared/SnackBarComponent';

export const BankLinkSecondStep = ({ accounts, has_primary, setShown, onComplete }) => {
    const radioGroupRef = useRef(null);
    const [payload, setPayload] = useState();
    const [sendingInfo, setSendingInfo] = useState(false);
    const SnackBarRef = useRef(null);

    const selectAccount = event => {
        let payload = {
            account_id: event.target.value,
            is_primary: true
        };
        setPayload(payload);
    };

    const sendInfo = () => {
        setSendingInfo(true);
        postAccountLinking(payload)
            .then(response => {
                setShown(false);
                onComplete();
            })
            .catch(error => {
                SnackBarRef.current.openSnackBar({
                    label: error.response?.data?.message,
                    severity: 'error'
                });
                setSendingInfo(false);
            });
    };

    const getAccountInfo = item => {
        return (
            <div>
                <Typography variant="subtitle2">{item.AccountName + ' - ' + item.AccountNumber}</Typography>
            </div>
        );
    };

    const cancelBankLinking = () => {
        deleteBankLinking()
            .then(response => {
                setShown(false);
            })
            .catch(err => {});
    };

    return (
        <>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateRows: 'auto min-content'
                }}>
                <RadioGroup ref={radioGroupRef} aria-label="accounts" name="accounts" onChange={selectAccount}>
                    {accounts.map((item, index) => {
                        return (
                            <FormControlLabel
                                key={item.AccountID}
                                value={item.AccountID}
                                control={<Radio />}
                                label={getAccountInfo(item)}
                            />
                        );
                    })}
                </RadioGroup>
                <Box
                    sx={{
                        marginTop: '1em',
                        justifyContent: 'space-between',
                        display: 'flex'
                    }}>
                    <IconButton onClick={cancelBankLinking}>
                        <ArrowBackIcon />
                    </IconButton>

                    <Button disabled={sendingInfo} variant="contained" onClick={sendInfo}>
                        {sendingInfo ? <CircularProgress size="20px" /> : 'Select Fund'}
                    </Button>
                </Box>
            </Box>
            <SnackBarComponent ref={SnackBarRef} />
        </>
    );
};
